<template>
  <v-container class="py-8" style="max-width: 800px">
    <v-btn variant="text" class="mb-4" :to="backTarget">&larr; Back</v-btn>
    <h1 class="text-h4 mb-2">Privacy Policy</h1>
    <p class="text-body-2 text-medium-emphasis mb-6">Last updated September 16, 2026</p>

    <p>
      Gigdriver is operated by Audionola ("Audionola", "we", "us"). This policy describes what
      information we collect through the Gigdriver application (the "Service") and how we use it.
    </p>

    <h2 class="text-h6 mt-6 mb-2">Information we collect</h2>
    <ul class="pl-4">
      <li><strong>Account information:</strong> name, email address, and profile photo, provided directly or via Google Sign-In.</li>
      <li><strong>Organization data:</strong> gigs, staffing positions, bookings, rates, venues, clients, and related scheduling and budget details that an organization's members enter into the Service.</li>
      <li><strong>Calendar data:</strong> we generate calendar invites (ICS) and per-member calendar feed URLs for bookings you accept, so the relevant event details are made available to your calendar application.</li>
      <li><strong>Billing/invoicing data:</strong> if an organization connects an invoicing provider, related client and invoice records are synced to enable that integration.</li>
      <li><strong>Usage data:</strong> standard technical logs (e.g. timestamps, error logs) generated by our hosting and backend infrastructure.</li>
    </ul>

    <h2 class="text-h6 mt-6 mb-2">How we use information</h2>
    <ul class="pl-4">
      <li>To provide and operate the Service, including authentication, scheduling, staffing offers, budgeting, and calendar/notification delivery.</li>
      <li>To send transactional email (e.g. offers, booking confirmations, cancellations) related to your use of the Service.</li>
      <li>To maintain the security and integrity of the Service.</li>
    </ul>

    <h2 class="text-h6 mt-6 mb-2">Sharing</h2>
    <p>
      We do not sell personal information. Information is shared only: within your organization (with
      other members who have access under your organization's roles), with service providers we use to
      operate Gigdriver (e.g. cloud hosting, transactional email delivery, and, if your organization
      enables it, an invoicing provider), and where required by law.
    </p>

    <h2 class="text-h6 mt-6 mb-2">Data retention</h2>
    <p>
      We retain account and organization data for as long as your account or organization remains active,
      or as needed to provide the Service. You may request deletion of your account by contacting us below.
    </p>

    <h2 class="text-h6 mt-6 mb-2">Your choices</h2>
    <p>
      You can review and update your account information from My Account, and can ask us to delete your
      account and associated personal data at any time.
    </p>

    <h2 class="text-h6 mt-6 mb-2">Contact</h2>
    <p>Questions about this policy can be sent to <a href="mailto:david@audionola.com">david@audionola.com</a>.</p>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAuthStore } from '../stores/auth';

const authStore = useAuthStore();
const backTarget = computed(() => (authStore.isAuthenticated ? '/' : '/login'));
</script>
